/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type userTracking_regionalInfo = {
    readonly incomeLevel: {
        readonly incomeBracket: string | null;
        readonly incomePercentile: string | null;
    } | null;
    readonly " $refType": "userTracking_regionalInfo";
};
export type userTracking_regionalInfo$data = userTracking_regionalInfo;
export type userTracking_regionalInfo$key = {
    readonly " $data"?: userTracking_regionalInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"userTracking_regionalInfo">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "userTracking_regionalInfo",
  "type": "RegionalInfo",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "zipCode",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "incomeLevel",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "zipCode",
          "variableName": "zipCode"
        }
      ],
      "concreteType": "IncomeLevel",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "incomeBracket",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "incomePercentile",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'f02bdb39ee092a2d4baa8aff15f762e3';
export default node;
